export default "__VITE_ASSET__d2d33217__"